import styled from 'styled-components';
import { Typography, Avatar } from 'antd';

import colors from '../../styles/colors';

const { Text } = Typography;

export const CardAttachments = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 28px;
`;
export const Title = styled(Text)`
  font-size: 14;
  color: ${props => props.color || colors.greyText};
`;

export const ContentAttachments = styled.div`
  width: 100%;
  padding: 0 12px;
  margin-top: 5px;
  border-radius: 2px;
  background-color: ${colors.gbGrey};
`;

export const ContainerImage = styled(Avatar)`
  border-radius: 2px;
`;
